<template>
  <div class="login">
    <div class="logo">
      <img src="@/assets/slogan.png" alt="" />
      <!-- <div class="slogon">
        <p>运输，</p>
        <p>还是顺丰运力靠谱</p>
      </div> -->
      <video muted autoplay loop src="@/assets/login.mp4">
        your browser does not support the video tag
      </video>
    </div>
    <div class="login-form">
      <div class="title">货主注册</div>
      <el-input
        placeholder="请输入手机号码"
        v-model.trim="phone"
        maxlength="11"
        @focus="showAccounts"
        class="input-with-select"
      >
      </el-input>
      <slider-code
        v-model="verifyPass"
        @on-success="listenFromVerify2"
      ></slider-code>
      <el-input v-model="vCode" placeholder="请输入验证码">
        <el-button
          class="vcode"
          slot="append"
          @click="getvCode('handleclick')"
          style="width: 140px"
          >{{ vcodeText }}</el-button
        >
      </el-input>
      <div class="account-pwd">
        <el-checkbox v-model="readFlag"
          >我已阅读并同意
          <span class="color_blue" @click.prevent="desClick(0)"
            >《用户服务协议》</span
          >与<span class="color_blue" @click.prevent="desClick(1)"
            >《隐私政策》</span
          >
          <!-- 、
          <span class="color_blue" @click.prevent="desClick(1)"
            >《隐私政策》</span
          >和
          <span class="color_blue" @click.prevent="desClick(2)"
            >《用户授权协议》</span
          > -->
        </el-checkbox>
      </div>
      <el-button type="danger" @click="onLogin">注册</el-button>
      <div class="goLogin">
        已有账号？ <span @click="goLogin">立即登录</span>
      </div>
    </div>
    <el-dialog
      title="安全验证"
      :visible.sync="dialogVisible"
      width="468px"
      :before-close="handleClose"
    >
      <div class="wrapper">
        <div class="tip">
          为了保障您的账户安全，确保是您本人操作，请进行安全验证
        </div>
        <div class="w">
          <el-input
            placeholder="请输入手机号码"
            v-model.trim="form.phone"
            disabled
            maxlength="11"
            @focus="showAccounts"
          >
          </el-input>
          <!-- <first-slider-code
              style="margin-top:10px;"
              v-model="verifyPass2"
              @on-success="listenFromVerify3"
            ></first-slider-code> -->
          <el-input
            class="vcodeStyle"
            v-model="form.vCode"
            placeholder="请输入验证码"
          >
            <el-button
              class="vcode"
              slot="append"
              @click="getAuthCode"
              style="width: 140px"
              >{{ authcodeText }}</el-button
            >
          </el-input>
          <el-button type="danger" style="width: 100%" @click="submit()"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 用户服务协议 -->
    <el-dialog
      :fullscreen="true"
      title="顺丰运力用户服务协议"
      :visible.sync="tipsDialogVisible"
      width="30%"
    >
      <pre>{{ text }}</pre>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipsDialogVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
    <!-- 隐私政策 -->
    <el-dialog
      :fullscreen="true"
      title="隐私政策"
      :visible.sync="tipsYSDialogVisible"
      width="30%"
    >
      <privacyPolicy @lookHistory="desClick(2)" @lookChildrenRule="desClick(3)"></privacyPolicy>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipsYSDialogVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
    <!-- 隐私政策历史版本 -->
    <el-dialog
      :fullscreen="true"
      title="隐私政策历史版本"
      :visible.sync="tipsLSBBDialogVisible"
      width="30%"
    >
      <privacyHistory @goCurrentVersion="desClick(1)"></privacyHistory>
    </el-dialog>
    <!-- 儿童个人信息保护规则 -->
    <el-dialog
      :fullscreen="true"
      title="儿童个人信息保护规则"
      :visible.sync="tipsChildrenDialogVisible"
      width="30%"
    >
      <childrenSafeRule></childrenSafeRule>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipsChildrenDialogVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { text1 } from "./text";
import sliderCode from "@/components/sliderCode";
import firstSliderCode from "./sliderCode";
import privacyPolicy from "./file/privacyPolicy/index.vue"
import privacyHistory from "./file/privacyHistory/index.vue"
import childrenSafeRule from "./file/childrenSafeRule/index.vue"
import { mapActions } from "vuex";
import aes from "@/utils/way";
export default {
  components: {
    sliderCode,
    firstSliderCode,
    privacyPolicy,
    privacyHistory,
    childrenSafeRule
  },
  data() {
    return {
      text: text1,
      rules: {
        telephone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入正确的联系方式",
            trigger: "blur",
          },
        ],
        vCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: /^\d{3,6}$/,
            message: "请输入正确的验证码",
            trigger: "blur",
          },
        ],
      },
      myTextList: [text1, 2, 3],
      tipsDialogVisible: false,
      tipsYSDialogVisible: false,
      tipsLSBBDialogVisible: false,
      tipsChildrenDialogVisible: false,
      form: {
        phone: "",
        vCode: "",
      },
      dialogVisible: false,
      accounts: [],
      isshowAccounts: false,
      readFlag: false,
      select: "1",
      phone: "",
      password: "",
      vCode: "",
      textConst: "获取验证码",
      vcodeText: "获取验证码",
      authcodeText: "获取验证码",
      verifyPass: false,
      verifyPass2: false,
      codekey: "",
      coordinate: "",
      flag: false,
      index: "",
    };
  },
  methods: {
    ...mapActions(["register", "sendVerifyCodeApi"]),
    goLogin() {
      this.$router.push("/");
    },
    desClick(val) {
      // this.tipsDialogVisible = true;
      this.index = val;
      switch(val) {
        case 0: //用户服务协议
          this.tipsDialogVisible = true;
          this.tipsYSDialogVisible = false;
          this.tipsLSBBDialogVisible = false;
          this.tipsChildrenDialogVisible = false;
          break;
        case 1: //隐私政策
          this.tipsDialogVisible = false;
          this.tipsYSDialogVisible = true;
          this.tipsLSBBDialogVisible = false;
          this.tipsChildrenDialogVisible = false;
          break;
        case 2: //隐私政策历史版本
          this.tipsDialogVisible = false;
          this.tipsYSDialogVisible = false;
          this.tipsLSBBDialogVisible = true;
          this.tipsChildrenDialogVisible = false;
          break;
        case 3: //儿童个人信息保护规则
          this.tipsDialogVisible = false;
          this.tipsYSDialogVisible = false;
          this.tipsLSBBDialogVisible = false;
          this.tipsChildrenDialogVisible = true;
          break;
        default:
          return false;
          break;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    submit() {
      this.onLogin(); // 输入验证码成功后再登录
      this.dialogVisible = false;
    },
    goSecret() {
      this.$router.push("/secret");
    },
    goRegister() {
      this.$router.push("/register");
    },
    showAccounts() {
      this.isshowAccounts = true;
    },
    hideAccounts() {
      setTimeout(() => {
        this.isshowAccounts = false;
      }, 100);
    },
    fillPhone(item) {
      console.log(item);
      this.phone = item;
      this.hideAccounts();
    },
    saveAccount() {
      let curr = localStorage.getItem("accounts");
      if (curr) {
        if (curr.indexOf(this.phone) == -1) {
          localStorage.setItem("accounts", curr + "," + this.phone);
        }
      } else {
        localStorage.setItem("accounts", this.phone);
      }
    },
    onLogin(type) {
      if (!this.readFlag) {
        this.$message.error("请先勾选我已阅读");
        return;
      }
      let params = {
        telephone: this.phone,
        // password: aes.encrypt(this.password),
        verifykey: this.coordinate,
        verifyid: this.codekey,
        vCode: this.vCode,
      };
      localStorage.setItem("changeAccounts", params.username);
      // const jwt = sessionStorage.getItem('jwt')
      // if (jwt) {
      //   params.jwt = jwt
      // }
      this.register(params)
        .then((res) => {
          this.$message.success("注册成功");
          this.$router.push({
            path: "/manage/HomePage",
            query: { isRegFlag: true },
          });
        })
        .catch((e) => {
          this.verifyPass = false;
        });
    },
    getAuthCode() {
      let mobile = localStorage.getItem("changeAccounts");
      let params = {
        mobile,
        isRegFlag: true,
      };
      this.sendVerifyCodeApi(params)
        .then((d) => {
          this.countChange();
        })
        .catch((e) => {});
    },
    getvCode(data) {
      let params = {};
      if (data === 'handleclick') {
        params.mobile = this.phone;
        params.isRegFlag = true;
        params.reqid = this.codekey;
        params.resultSet = this.coordinate;
      } else {
        params.mobile = this.phone;
        params.isRegFlag = true;
        params.reqid = data.reqid;
        params.resultSet = data.resultSet;
      }
      if (!this.verifyPass) {
        this.$message({
          type: "warning",
          message: "请移动滑块，完成拼图验证",
        });
        return;
      }
      if (this.vcodeText != this.textConst) {
        return;
      }
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone)) {
        this.$message({
          type: "warning",
          message: "请输入正确的手机号",
        });
        return;
      }
      this.sendVerifyCodeApi(params)
        .then((d) => {
          this.countdown();
        })
        .catch((e) => {});
    },
    countChange() {
      let seconds = 60;
      let tm = setInterval(() => {
        if (seconds == 0) {
          this.authcodeText = this.textConst;
          clearInterval(tm);
          return;
        }
        this.authcodeText = seconds + "S";
        seconds--;
      }, 1000);
    },
    countdown() {
      let seconds = 60;
      let tm = setInterval(() => {
        if (seconds == 0) {
          this.vcodeText = this.textConst;
          clearInterval(tm);
          return;
        }
        this.vcodeText = seconds + "S";
        seconds--;
      }, 1000);
    },
    listenFromVerify(data) {
      this.codekey = data.reqid;
      this.coordinate = data.resultSet;
    },
    listenFromVerify2(data) {
      this.codekey = data.reqid;
      this.coordinate = data.resultSet;
      this.getvCode(data);
    },
    listenFromVerify3(data) {
      this.codekey = data.reqid;
      this.coordinate = data.resultSet;
      this.getvCode(data);
    },
  },
  created() {
    let phone = localStorage.getItem("accounts");
    if (phone) {
      this.accounts = phone.split(",");
      this.phone = this.accounts[this.accounts.length - 1];
    }
  },
  mounted() {
    let that = this;
    document.body.addEventListener("click", (event) => {
      if ("el-input__inner" !== event.target.className) {
        that.hideAccounts();
      }
    });
  },
  /* watch: {
    readFlag() {
      this.saveAccount();
    },
  }, */
};
</script>
<style lang="less" scoped>
.login {
  .title {
    position: absolute;
    right: 220px;
    top: 40px;
    z-index: 999;
    color: #fff;
    font-size: 20px !important;
  }
}
.accounts {
  position: absolute;
  top: 50px;
  left: 0px;
  width: 388px;
  box-shadow: 0 0px 5px #95b2e2;
  min-height: 80px;
  background-color: #2b3d5b;
  color: #fff;
  font-size: 14px;
  z-index: 10000;
  ul {
    list-style: none;
    padding-left: 0;
    line-height: 2.4;
    margin: 0 !important;
    li {
      padding-left: 10px !important;
      cursor: pointer;
      &:hover {
        background-color: rgb(31, 46, 74);
      }
    }
  }
}
.login-form {
  /deep/ .el-input.is-active .el-input__inner,
  /deep/ .el-input__inner:focus {
    border-color: transparent !important;
  }
}
.login .login-form .account-pwd /deep/ span {
  color: #fff;
  &.el-checkbox__input {
    margin-right: 5px !important;
  }
}
.wrapper {
  padding: 20px !important;
  .tip {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.55);
    line-height: 24px;
    margin: 20px 0 !important;
    text-align: center;
  }
  .w {
    height: 240px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}

.wrapper /deep/ .el-input-group__append {
  background-color: transparent;
}
.vcodeStyle /deep/ .el-input__inner {
  border-right: none;
}
.wrapper /deep/ .el-button {
  height: 45px;
}
.color_blue {
  color: #84a9f2 !important;
}
.goLogin {
  width: 100%;
  height: 50px !important;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  color: #fff !important;
  span {
    cursor: pointer;
    color: #e34b5b;
  }
}
</style>  